import React from 'react';
import CloseIcon from '@mui/icons-material/Close';
import { IconButton } from '@mui/material';
import ReplyMessageBubble from '../ReplyMessage';
import {
    ReplyingContainer,
    ReplyingHeader,
    ReplyingBubble,
    ReplyingOwner,
    CloseButtonWrapper
} from './styled';
import { ConversationMessage } from 'src/types/chat';

type Props = {
    message: ConversationMessage;
    onCancel: () => void;
};

const ReplyComposer: React.FC<Props> = ({ message, onCancel }) => {
    return (
        <ReplyingContainer>
            <ReplyingHeader>Replying to message</ReplyingHeader>
            <ReplyingBubble>
                <ReplyingOwner>
                    {message.isOwn ? 'me' : message.senderAlias || 'Unknown'}
                </ReplyingOwner>
                <ReplyMessageBubble
                    replyMessage={message}
                    sentByMe={message.isOwn}
                />
                <CloseButtonWrapper>
                    <IconButton size="small" onClick={onCancel}>
                        <CloseIcon fontSize="small" />
                    </IconButton>
                </CloseButtonWrapper>
            </ReplyingBubble>
        </ReplyingContainer>
    );
};

export default ReplyComposer;
